import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ViewComplain from "./viewComplain";
import {
  complainRaisedTicket,
  closeComplain,
  viewDetails,
  reopenComplain,
  saveComplaintReply,
  getCategoryCX,
  setCategoryCX,
  closeDuplicateComplaint,
  fetchFaqs,
  ticketCategories,
  updateComplainCategories
} from "services/redux/fileComplain/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    complainList: state.fileComplainReducer.fetchComplain,
    viewComplainDetails: state.fileComplainReducer.viewComplain,
    duplicateComplainClosed: state.fileComplainReducer.duplicateComplain
    // categoryList: state.fileComplainReducer.getCategoryCXCategory,
    // l1List: state.fileComplainReducer.getCategoryCXL1,
    // l2List: state.fileComplainReducer.getCategoryCXL2,
    // l3List: state.fileComplainReducer.getCategoryCXL3
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    documentUploadUrlPublic,
    closeComplain,
    reopenComplain,
    viewDetails,
    complainRaisedTicket,
    saveComplaintReply,
    getCategoryCX,
    setCategoryCX,
    closeDuplicateComplaint,
    fetchFaqs,
    ticketCategories,
    updateComplainCategories
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ViewComplain);
